module.exports = __webpack_public_path__ + "static/img/mgzjz.8bc9b89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/mgzjz.png
// module id = klog
// module chunks = 0